<template>
  <button class="venue-info-widget" aria-label="View venue info" @click="handleWidgetInfoClick">
    <i class="venue-info-widget__icon icon icon-Info" aria-hidden="true"></i>
  </button>
  <venue-info-modal ref="modalRef" v-bind="props" />
</template>

<script setup>
import { ref } from 'vue';
import VenueInfoModal from '../../VenueInfoModal/VenueInfoModal.vue';

const emit = defineEmits(['widgetInfoClick']);

const props = defineProps({
  locationId: {
    type: [String, Number],
  },
  venueId: {
    type: [String, Number],
  },
  dates: {
    type: Object,
    default: () => ({}),
  },
  headingType: {
    type: String,
    default: 'h3',
  },
  showVenueInfoFirst: {
    type: Boolean,
    default: true,
  },
});

const modalRef = ref(null);

const handleWidgetInfoClick = () => {
  if (!modalRef.value) return;
  emit('widgetInfoClick');
  modalRef.value.openModal();
};
</script>

<style lang="scss">
@import './scss/VenueInfoWidget.scss';
</style>
